import React from 'react';

import PropTypes from 'prop-types';

import { RadioGroup, Radio } from "react-icheck";
import EnhancedSwitch from 'react-icheck/lib/EnhancedSwitch';

import { Grid, Row } from '../../../layout';
import "icheck/skins/all.css";

EnhancedSwitch.propTypes = {
	...EnhancedSwitch.propTypes,
	cursor: PropTypes.string
  }

export class RadioOptions extends React.PureComponent {
	radios() {
		let { options, input } = this.props;

		return options.map((option, index) => {
			return (
				<Radio
					key={index}
					{...input}
					radioClass="iradio_square-blue"
					cursor="pointer"
					label={` ${option.label}`}
					value={option.value.toString()}
				/>
			);
		});
	}

	render() {
		const {
			input, meta: { touched, error }
		} = this.props;
		const rowError = (touched && error ? { border: '.1rem solid #dd4b39', borderRadius: '1rem'} : null);
		return (
			<Grid cols={this.props.cols}>
				<div
					className={`form-group ${touched && error && "has-error"}`}
				>
					<Row style={{ marginLeft: 0 }}>
						{touched && error ? (
							<label className="control-label">
								<i className="fa fa-times-circle-o" />
								&nbsp;&nbsp;
								{this.props.label}
							</label>
						) : (
							<label htmlFor={this.props.name}>
								{this.props.label}
							</label>
						)}
					</Row>
					<Row style={{ marginLeft: 0, ...rowError}}>
						<RadioGroup name={input.name} value={input.value}>
							{this.radios()}
						</RadioGroup>
					</Row>
					<Row style={{ marginLeft: 0 }}>
						{touched && error && (
							<span className="help-block">{error}</span>
						)}
					</Row>
				</div>
			</Grid>
		);
	}
}